import React, { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Toolbar from "./components/Toolbar";
import Notebook from "./components/Notebook";
import Footer from "./components/Footer";
import { personalInfo } from "./data/mock";
import "./App.css";

const Home = () => {
  const [kernel, setKernel] = useState("idle");
  const [runNonce, setRunNonce] = useState(0);
  const [filename, setFilename] = useState(personalInfo.filename);
  const [filesOpen, setFilesOpen] = useState(false);

  const pulse = useCallback(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      setKernel("idle");
      return;
    }
    setKernel("busy");
    window.setTimeout(() => setKernel("idle"), 640);
  }, []);

  useEffect(() => {
    pulse();
  }, [pulse]);

  const run = useCallback(() => {
    setRunNonce((n) => n + 1);
  }, []);

  return (
    <div className="nb-app">
      <Toolbar
        kernel={kernel}
        filename={filename}
        onRun={run}
        filesOpen={filesOpen}
        onFilesToggle={() => setFilesOpen((v) => !v)}
      />
      <main>
        <Notebook
          runNonce={runNonce}
          onPulse={pulse}
          onTitle={setFilename}
          filesOpen={filesOpen}
          onOpened={() => setFilesOpen(false)}
        />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
